import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {AuthService} from '../../../services/auth/auth.service';
import {LeftNavbarService} from '../../../services/left-navbar/left-navbar.service';
import {User} from '../../../models/user';
import {RouterLink} from '@angular/router';
import { NgOptimizedImage } from '@angular/common';
import {ImageService} from '../../../services/image/image.service';
import {Partner} from '../../../models/partner';

@Component({
  selector: 'app-top-navbar',
  imports: [
    RouterLink
  ],
  templateUrl: './top-navbar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './top-navbar.component.scss'
})
export class TopNavbarComponent implements OnInit {

  connectedUser: Partner | null = null;

  constructor(
    protected imageService: ImageService,
    private auth: AuthService,
    private leftNavbarService: LeftNavbarService,
  ) {
  }

  ngOnInit(): void {
    this.auth.getConnectedUser().subscribe((connectedUser) => {
      this.connectedUser = connectedUser;
    });
  }

  logout(): void {
    this.auth.logout();
  }

  toggle(): void {
    this.leftNavbarService.toggle();
  }
}
